import React, { useState } from "react";
import Swal from "sweetalert2";
import { getAbout, getAdminBoxTxt, getContact, getService } from "../../Services/textService";
import { updateAdminBoxTxt } from "../../Services/userService";
import myContext from "./myContext";
import { getHome } from "./../../Services/textService";

const GlobalState = (props) => {
    const [OAB1F1, setOAB1F1] = useState({});
    const [OAB1F2, setOAB1F2] = useState({});
    const [OAB1F3, setOAB1F3] = useState({});
    const [OAB1F4, setOAB1F4] = useState({});
    const [OAB1F5, setOAB1F5] = useState({});
    const [OAB1F6, setOAB1F6] = useState({});
    const [OAB2F1, setOAB2F1] = useState({});
    const [OAB2F2, setOAB2F2] = useState({});
    const [OAB2F3, setOAB2F3] = useState({});
    const [OAB2F4, setOAB2F4] = useState({});
    const [OAB3F1, setOAB3F1] = useState({});
    const [OAB3F2, setOAB3F2] = useState({});
    const [OAB3F3, setOAB3F3] = useState({});
    const [OAB3F4, setOAB3F4] = useState({});
    const [OAB3F5, setOAB3F5] = useState({});
    const [OAB3F6, setOAB3F6] = useState({});
    const [OAB4F1, setOAB4F1] = useState({});
    const [AdminPresent, setAdminPresent] = useState(false);
    const [homeObject, sethomeObject] = useState({});
    const [aboutObject, setaboutObject] = useState({});
    const [serviceObject, setserviceObject] = useState({});
    const [contactObject, setcontactObject] = useState({});

    // Init Page Data
    const SetInitHomePage = async () => {
        try {
            var resault = await getHome();
            var data = resault.data;
            const homePageObject = {
                v1: data["v1"],
                v2: data["v2"],
                v3: data["v3"],
                v4: data["v4"],
                v5: data["v5"],
                v6: data["v6"],
                v7: data["v7"],
                v8: data["v8"],
                v9: data["v9"],
                v10: data["v10"],
                v11: data["v11"],
                v12: data["v12"],
                v13: data["v13"],
                v14: data["v14"],
                v15: data["v15"],
                v16: data["v16"],
                v17: data["v17"],
                v18: data["v18"],
                v19: data["v19"],
                v20: data["v20"],
                v21: data["v21"],
                v22: data["v22"],
                v23: data["v23"],
                v24: data["v24"],
                v25: data["v25"],
                v26: data["v26"],
                v27: data["v27"],
                v28: data["v28"],
                v29: data["v29"],
                v30: data["v30"],
                v31: data["v31"],
                v32: data["v32"],
                v33: data["v33"],
                v34: data["v34"],
                v35: data["v35"],
                v36: data["v36"],
                v37: data["v37"],
                v38: data["v38"],
                v39: data["v39"],
                v40: data["v40"],
                v41: data["v41"],
                v42: data["v42"],
                v43: data["v43"],
                v44: data["v44"],
            };
            sethomeObject(homePageObject);
        } catch (error) {
            console.log("خطا در دریافت داده");
        }
    };

    const SetInitAboutPage = async () => {
        try {
            var resault = await getAbout();
            var data = resault.data;
            const aboutPageObject = {
                v1: data["v1"],
                v2: data["v2"],
                v3: data["v3"],
                v4: data["v4"],
                v5: data["v5"],
                v6: data["v6"],
                v7: data["v7"],
                v8: data["v8"],
                v9: data["v9"],
                v10: data["v10"],
                v11: data["v11"],
                v12: data["v12"],
                v13: data["v13"],
                v14: data["v14"],
                v15: data["v15"],
                v16: data["v16"],
                v17: data["v17"],
                v18: data["v18"],
                v19: data["v19"],
            };
            setaboutObject(aboutPageObject);
        } catch (error) {
            console.log("خطا در دریافت داده");
        }
    };

    const SetInitServicePage = async () => {
        try {
            var resault = await getService();
            var data = resault.data;
            const servicePageObject = {
                v1: data["v1"],
                v2: data["v2"],
                v3: data["v3"],
                v4: data["v4"],
                v5: data["v5"],
                v6: data["v6"],
                v7: data["v7"],
                v8: data["v8"],
                v9: data["v9"],
                v10: data["v10"],
                v11: data["v11"],
                v12: data["v12"],
                v13: data["v13"],
                v14: data["v14"],
                v15: data["v15"],
                v16: data["v16"],
                v17: data["v17"],
                v18: data["v18"],
                v19: data["v19"],
                v20: data["v20"],
                v21: data["v21"],
                v22: data["v22"],
                v23: data["v23"],
                v24: data["v24"],
                v25: data["v25"],
                v26: data["v26"],
                v27: data["v27"],
                v28: data["v28"],
                v29: data["v29"],
                v30: data["v30"],
                v31: data["v31"],
                v32: data["v32"],
                v33: data["v33"],
                v34: data["v34"],
                v35: data["v35"],
            };
            setserviceObject(servicePageObject);
        } catch (error) {
            console.log("خطا در دریافت داده");
        }
    };
    const SetInitContactPage = async () => {
        try {
            var resault = await getContact();
            var data = resault.data;
            const contactPageObject = {
                v1: data["v1"],
                v2: data["v2"],
                v3: data["v3"],
                v4: data["v4"],
                v5: data["v5"],
                v6: data["v6"],
                v7: data["v7"],
            };
            setcontactObject(contactPageObject);
        } catch (error) {
            console.log("خطا در دریافت داده");
        }
    };

    // Admin Login & Logout
    const LogInAdmin = async () => {
        await setAdminPresent(true);
    };
    const LogOutAdmin = async () => {
        await setAdminPresent(false);
    };

    // find State for other methods
    const findAB1FormByNum = (n) => {
        switch (n) {
            case 1:
                return [OAB1F1, setOAB1F1, { ...OAB1F1 }];
            case 2:
                return [OAB1F2, setOAB1F2, { ...OAB1F2 }];
            case 3:
                return [OAB1F3, setOAB1F3, { ...OAB1F3 }];
            case 4:
                return [OAB1F4, setOAB1F4, { ...OAB1F4 }];
            case 5:
                return [OAB1F5, setOAB1F5, { ...OAB1F5 }];
            case 6:
                return [OAB1F6, setOAB1F6, { ...OAB1F6 }];
            default:
                break;
        }
    };

    const findAB2FormByNum = (n) => {
        switch (n) {
            case 1:
                return [OAB2F1, setOAB2F1, { ...OAB2F1 }];
            case 2:
                return [OAB2F2, setOAB2F2, { ...OAB2F2 }];
            case 3:
                return [OAB2F3, setOAB2F3, { ...OAB2F3 }];
            case 4:
                return [OAB2F4, setOAB2F4, { ...OAB2F4 }];
            default:
                break;
        }
    };

    const findAB3FormByNum = (n) => {
        switch (n) {
            case 1:
                return [OAB3F1, setOAB3F1, { ...OAB3F1 }];
            case 2:
                return [OAB3F2, setOAB3F2, { ...OAB3F2 }];
            case 3:
                return [OAB3F3, setOAB3F3, { ...OAB3F3 }];
            case 4:
                return [OAB3F4, setOAB3F4, { ...OAB3F4 }];
            case 5:
                return [OAB3F5, setOAB3F5, { ...OAB3F5 }];
            case 6:
                return [OAB3F6, setOAB3F6, { ...OAB3F6 }];
            default:
                break;
        }
    };

    const findAB4FormByNum = () => {
        return [OAB4F1, setOAB4F1, { ...OAB4F1 }];
    };

    //get init data
    const SetInitData = async (x, y, z) => {
        let state = null;
        switch (x) {
            case 1:
                state = findAB1FormByNum(y)[1];
                break;
            case 2:
                state = findAB2FormByNum(y)[1];
                break;
            case 3:
                state = findAB3FormByNum(y)[1];
                break;
            case 4:
                state = findAB4FormByNum(y)[1];
                break;

            default:
                break;
        }

        try {
            var resault = await getAdminBoxTxt(z);
            var data = resault.data;
            const Form = {
                v1: data["v1"],
                v2: data["v2"],
                v3: data["v3"],
                v4: data["v4"],
                v5: data["v5"],
                v6: data["v6"],
                v7: data["v7"],
                v8: data["v8"],
                v9: data["v9"],
                v10: data["v10"],
                v11: data["v11"],
                v12: data["v12"],
                v13: data["v13"],
                v14: data["v14"],
                v15: data["v15"],
                v16: data["v16"],
            };
            state(Form);
        } catch (error) {
            Swal.fire("Oops...", "Something went wrong!", "error");
            console.log(error + "خطا در دریافت داده");
        }
    };

    // Update Data Method
    // x AdminBox number - y Form number - z id
    const handleSubmit = async (x, y, z) => {
        let state = null;
        switch (x) {
            case 1:
                state = findAB1FormByNum(y)[0];
                break;
            case 2:
                state = findAB2FormByNum(y)[0];
                break;
            case 3:
                state = findAB3FormByNum(y)[0];
                break;
            case 4:
                state = findAB4FormByNum(y)[0];
                break;

            default:
                break;
        }

        const From = {
            TxtId: z,
            v1: state["v1"],
            v2: state["v2"],
            v3: state["v3"],
            v4: state["v4"],
            v5: state["v5"],
            v6: state["v6"],
            v7: state["v7"],
            v8: state["v8"],
            v9: state["v9"],
            v10: state["v10"],
            v11: state["v11"],
            v12: state["v12"],
            v13: state["v13"],
            v14: state["v14"],
            v15: state["v15"],
            v16: state["v16"],
        };
        try {
            const { status } = await updateAdminBoxTxt(z, From);
            if (status === 200) {
                Swal.fire("Page Edited Successfully!");
            }
        } catch (error) {
            Swal.fire("Oops...", "Something went wrong!", "error");
            console.log(error + "خطا در ثبت داده ها");
        }
    };

    // e event - x AdminBox number - y Form number - z value number
    const chageStateMethod = (e, x, y, z) => {
        let pervState = null;

        switch (x) {
            case 1:
                pervState = findAB1FormByNum(y)[2];
                pervState[z] = e.target.value;
                findAB1FormByNum(y)[1](pervState);
                break;
            case 2:
                pervState = findAB2FormByNum(y)[2];
                pervState[z] = e.target.value;
                findAB2FormByNum(y)[1](pervState);
                break;
            case 3:
                pervState = findAB3FormByNum(y)[2];
                pervState[z] = e.target.value;
                findAB3FormByNum(y)[1](pervState);
                break;
            case 4:
                pervState = findAB4FormByNum()[2];
                pervState[z] = e.target.value;
                findAB4FormByNum(y)[1](pervState);
                break;

            default:
                break;
        }
    };

    return (
        <myContext.Provider
            value={{
                OAB1F1,
                OAB1F2,
                OAB1F3,
                OAB1F4,
                OAB1F5,
                OAB1F6,
                OAB2F1,
                OAB2F2,
                OAB2F3,
                OAB2F4,
                OAB3F1,
                OAB3F2,
                OAB3F3,
                OAB3F4,
                OAB3F5,
                OAB3F6,
                OAB4F1,
                AdminPresent,
                homeObject,
                aboutObject,
                serviceObject,
                contactObject,
                chageStateMethod,
                LogInAdmin,
                LogOutAdmin,
                SetInitHomePage,
                SetInitAboutPage,
                SetInitServicePage,
                SetInitContactPage,
                SetInitData,
                handleSubmit,
            }}
        >
            {props.children}
        </myContext.Provider>
    );
};

export default GlobalState;
